angular.module('ikeweb.spike.measure').provider('photogrammetryToolKit', function() {

    var pm = require('@ikegps/spike-photogrammetry-toolkit');

    return {
        setStyles: function(styles) {
            Object.keys(styles).forEach(function(item) {
                pm.Measurement.Styles[item] = styles[item];
            });
        },
        $get: function() {
            return pm;
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./src/client/components/spike/measure/photo-measure/photogrammetry.toolkit.provider.js
// module id = 530
// module chunks = 0